export class ActivationToken {
  uid64: string;
  token: string;
  constructor(uid64: string, token: string ) {
    this.uid64 = uid64;
    this.token = token;
  }
}
